import { Card, CardContent } from '@/components/ui/card'
import type { PromptStats } from '@/types'

interface PromptsStatsCardsProps {
  stats: PromptStats | undefined
  isLoading: boolean
}

const cardClass = "rounded-2xl shadow-none h-[130px] border-border"
const cardContentClass = "px-4 pt-2 pb-4 flex flex-col h-full text-foreground"
const titleClass = "text-sm font-normal leading-[160%] tracking-[0.015em] text-foreground"
const numberClass = "text-[32px] font-bold leading-[130%] tracking-[0.015em] text-foreground"
const subtitleClass = "text-sm font-normal leading-[160%] tracking-[0.015em] mt-auto text-foreground"

export function PromptsStatsCards({ stats, isLoading }: PromptsStatsCardsProps) {
  if (isLoading) {
    return (
      <div className="grid grid-cols-4 gap-4">
        {Array.from({ length: 4 }).map((_, i) => (
          <Card key={i} className={cardClass}>
            <CardContent className={cardContentClass}>
              <div className="h-4 w-20 bg-muted animate-pulse rounded" />
              <div className="h-8 w-12 bg-muted animate-pulse rounded" />
            </CardContent>
          </Card>
        ))}
      </div>
    )
  }

  return (
    <div className="grid grid-cols-4 gap-4">
      <Card className={cardClass}>
        <CardContent className={cardContentClass}>
          <p className={titleClass}>Total Prompts</p>
          <p className={numberClass}>{stats?.totalPrompts ?? 0}</p>
          <p className={subtitleClass}>
            {(stats?.totalPrompts ?? 0) === 0
              ? 'No prompts'
              : stats?.projectPhaseStats.every((p) => p.allDefaults)
                ? 'All defaults'
                : 'Configured prompts'}
          </p>
        </CardContent>
      </Card>
      {stats?.projectPhaseStats.map((projectPhase) => (
        <Card key={projectPhase.projectPhaseId} className={cardClass}>
          <CardContent className={cardContentClass}>
            <div className="flex items-center gap-2">
              <div
                className="h-2.5 w-2.5 rounded-full"
                style={{ backgroundColor: projectPhase.projectPhaseDisplayColor }}
              />
              <p className={titleClass}>{projectPhase.projectPhaseName}</p>
            </div>
            <p className={numberClass}>{projectPhase.count}</p>
            <p className={subtitleClass}>
              {projectPhase.count === 0
                ? 'No prompts'
                : projectPhase.allDefaults
                  ? 'All defaults'
                  : 'Configured prompts'}
            </p>
          </CardContent>
        </Card>
      ))}
    </div>
  )
}
